import React from "react";
import { Outlet, Link, useParams } from 'react-router-dom';
import { useEffect, useState } from "react";
import Background from "../components/background";
import styled from 'styled-components';

const TextLink = styled(Link)`
margin-bottom :10px;
&:focus, &:hover, &:visited, &:link, &:active {
    color:#fff;
}
&:hover{
    color:#00ff00;
}
`;

const Artefacts = () => {

    document.addEventListener("mousemove", function (event) {
        if(document.getElementById("desktopMenu") != null){
            const nav = document.getElementById("navMenu");
            nav.style.transform = "translateY(0)";
            nav.style.transition = "transform 0.3s ease-in-out";
        }
    })

    return (
        <div>
            <Background />
            <div className="ProjectInfoContainer">
                <div className="ProjectInfo">
                    <p className="highlightInfo">EXPANDING THE CYPHERDUDES ECOSYSTEM</p>
                    <p>The cypherdudes projects is growing from within. Owners can collect artefacts for their cypherdudes to augment their capacity. The artefacts are separate interactive collection, embedding new interactive features.</p>
                    <p>In order to concentrate the provenance into the cypherdudes tokens, we use the <TextLink target="_blank" to={`https://eips.ethereum.org/EIPS/eip-6551`}> erc6551 Standard</TextLink> (Token-Bound-Account).</p>
                    <p>This standard allows any erc721 tokens to own other tokens. The ownership is transfered from the main token owner to the nested wallet. If the main token is transfered, the nested wallet ownership is transfered to the new owner.</p>
                    <p>In the cypherdudes project, the nested tokens are soul-bound to the nested wallet. The artefacts can't be separated from their cypherdudes. The supply of these artefacts will follow a halving mechanism.</p>
                    <p>When you collect an artefact, you collect a new trait for your cypherdude.</p>
                </div>
                <div className="ProjectInfo">
                    <p className="highlightInfo">ARTEFACTS LIST</p>
                    <ul>
                        <li>2048.....: <TextLink to="dos">DECENTRALIZED OPERATING SYSTEM</TextLink> (July 2026)</li>
                        <li>1024.....: <TextLink to="cypherpagers">CYPHERPAGER</TextLink> (July 2026)</li>
                        <li>512......: <TextLink to="cypherpalaces">CYPHERPALACE</TextLink> (Feb. 2025)</li>
                        <li>256......: -</li>
                        <li>128......: -</li>
                        <li>64.......: -</li>
                        <li>32.......: -</li>
                        <li>16.......: <TextLink to="cypherboards">CYPHERBOARDS</TextLink> (June 2025)</li>
                        <li>8........: -</li>
                        <li>4........: -</li>
                        <li>2........: -</li>
                        <li>1........: -</li>
                    </ul>
                </div>
                <div>
                    <Outlet />
                </div>
            </div>
        </div>
    )
}
export default Artefacts;